import React from "react";
import { ArrowUpRight } from "lucide-react";
import "./Header.css";

function Header({ title, subtitle, actionBtn }) {
  return (
    <div className="Header">
      <h1>{title}</h1>
      <p>{subtitle}</p>
      {actionBtn && (
        <button>
          {actionBtn} <ArrowUpRight />
        </button>
      )}
    </div>
  );
}

export default Header;
